// SuperAdminHome.js
import React, { useEffect, useState, useContext } from 'react';
import { UserContext } from "../UserContext";
import Header from '../Header';
import apiClient from '../../api/client';
import ExpiryOverview from '../ExpiryOverview';
import LoadError from '../LoadError';
import { getErrorMessage } from '../../utils/network';
import { formatCount } from '../../utils/expiry';
import { useNavigate } from 'react-router-dom';
import {
  FaUsers, 
  FaWallet, 
  FaChevronRight, 
  FaUserPlus,
} from 'react-icons/fa';
import { BiSolidUserVoice } from "react-icons/bi";
import AnnouncementModal from '../AnnouncementModal';
import QRCodeModal from "../QRCodeModal";
import DevicesModal from '../NmsDevices/DevicesModal';
import { FiServer } from 'react-icons/fi';

const OperatorHome = () => {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();
  const internetEnabled = user.internetEnabled;
  const dvplEnabled = user.dvplEnabled;

  const [dashboardData, setDashboardData] = useState({
    totalCustomers: 0,
    totalWallet: 0,
  });

  const [loading, setLoading] = useState(true);
  // Without this, a failed load (e.g. no internet) showed every card as 0.
  const [dashError, setDashError] = useState(null);
  const [showAnnouncement, setShowAnnouncement] = useState(false);
  const [showQRModal, setShowQRModal] = useState(false);
  const [showDevices, setShowDevices] = useState(false);

  const openQRCodeModal = () => setShowQRModal(true);
  const closeQRCodeModal = () => setShowQRModal(false);

  // Check if modal should be shown on component mount
  useEffect(() => {
    // Create a unique key for this user's login session
    const announcementKey = `announcementShown_${user?.operatorId}`;
    
    // Check if we've already shown the announcement for this login session
    const announcementShown = localStorage.getItem(announcementKey);
    
    if (!announcementShown) {
      setShowAnnouncement(true);
      // Mark that we've shown the announcement for this login session
      localStorage.setItem(announcementKey, 'true');
    }
    
  }, [user]);

  const fetchDashboard = async () => {
    try {
      setDashError(null);
      const { data } = await apiClient.get('/dashboard/operator_dashboard.php');
      setDashboardData(data);
      setLoading(false);
    } catch (err) {
      console.error('Failed to fetch dashboard:', err);
      setDashError(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboard();
  }, []);

  // Format number with commas
  // Indian grouping (1,23,456) and safe if the API returns nothing.
  const formatNumber = formatCount;

  const handleCloseAnnouncement = () => {
    setShowAnnouncement(false);
  };

  return (
    <>
      <Header />
      <div className="superadmin-dashboard">

        {/* {showAnnouncement && (
          <AnnouncementModal onClose={handleCloseAnnouncement} />
        )} */}

        {showDevices && <DevicesModal onClose={() => setShowDevices(false)} />}

        {showQRModal && (
          <QRCodeModal
            operatorId={user?.operatorId}
            operatorName={user?.name || "Operator"}
            onClose={closeQRCodeModal}
          />
        )}
        
        <div className="app-link alt-purple">
          <div className='dash-add-amount'>
            <h1>Dashboard</h1>
              <div className="action-buttons">
                <button onClick={openQRCodeModal} className='add-money'>₹ Add Money</button>
              </div>
          </div>
          {(user?.createdBy === 1 || user?.createdBy === "1") ? (
            <p><span className='app-head'>Please share payment details to:</span> 9703388253 or 9125253535</p>
          ) : ("")}
        </div>

        {loading ? (
          <div className="dashboard-loading">
            <div className="loader"></div>
            <p>Loading dashboard data...</p>
          </div>
        ) : dashError ? (
          <LoadError
            error={dashError}
            message={getErrorMessage(dashError, 'Could not load the dashboard.')}
            onRetry={() => { setLoading(true); fetchDashboard(); }}
          />
        ) : (
          <>
            <div className="dashboard-cards">
              
              <div className="card customer-card" onClick={() => {navigate('/customers')}}>
                <div className="card-icon">
                  <FaUsers />
                </div>
                <div className="card-content">
                  <h2>{formatNumber(dashboardData.totalCustomers)}</h2>
                  <p>Customers</p>
                </div>
                <div className="card-arrow">
                  <FaChevronRight />
                </div>
              </div>

              {internetEnabled && (
                <div className="card internet-customers-card" onClick={() => navigate('/internet-customers')}>
                  <div className="card-icon">
                    <BiSolidUserVoice />
                  </div>
                  <div className="card-content">
                    <h2 style={{ fontSize: '1.1rem' }}>Pioneer</h2>
                    <p>Customers</p>
                  </div>
                  <div className="card-arrow">
                    <FaChevronRight />
                  </div>
                </div>
              )}

              {
                dvplEnabled && (
                  <div className="card dvpl-customers-card" onClick={() => navigate('/dvpl-customers')}>
                    <div className="card-icon">
                      <BiSolidUserVoice />
                    </div>
                    <div className="card-content">
                      <h2 style={{ fontSize: '1.1rem' }}>DVPL</h2>
                      <p>Customers</p>
                    </div>
                    <div className="card-arrow">
                      <FaChevronRight />
                    </div>
                  </div>
                )
              }
              
              <div className="card wallet-card" onClick={() => {navigate('/wallet-history')}}>
                <div className="card-icon">
                  <FaWallet />
                </div>
                <div className="card-content">
                  <h2>₹{formatNumber(dashboardData.totalWallet)}</h2>
                  <p>Total Wallet</p>
                </div>
                <div className="card-arrow">
                  <FaChevronRight />
                </div>
              </div>
            </div>

            {/* Quick Actions at the very top, outside the loading state, so they show at once */}
        <div className='quick-actions'>
          <h3>Quick Actions</h3>
          <div className="action-buttons">
            <button className="action-btn customer-btn" onClick={() => navigate('/add-customer')}>
              <FaUserPlus />
              <span>Add Customer</span>
            </button>
            <button className="action-btn admin-btn" onClick={() => setShowDevices(true)}>
              <FiServer />
              <span>Devices</span>
            </button>
          </div>
        </div>
            
            <ExpiryOverview />

          </>
        )}
      </div>
    </>
  );
};

export default OperatorHome;